import React from 'react';
import styles from './styles/Loading.module.css';

const Loading = () => {
    return (
        <div className={styles.loaderContainer}>
            <div className={styles.spinner}>
                <div className={styles.dot}></div>
                <div className={styles.dot}></div>
                <div className={styles.dot}></div>
            </div>
            <p className={styles.loadingText}>Loading<span className={styles.animatedEllipsis}></span></p>
        </div>
    );
};

export default Loading;